import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ActionDetailsOverlay from "./ActionDetailsOverlay";

export const ActionsCell = ({ value, row, className, onClickBtn }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    setShowOverlay(true);
  };

  return (
    <StyledCell
      className={className}
    >
      <button
        className={row.finalActionStatus === true ? 'btn btn-default btn-subscriber disabled' : 'btn btn-default btn-subscriber'}
        disabled={row.finalActionStatus === true}
        title={row.finalActionStatus === true ? 'Watch (Completed/failed actions cannot be watched)' : 'Watch'}
        onClick={() => onClickBtn(row)}>
        <i className="fa-light fa-bell-on"/>
      </button>
      <button
        className='btn btn-default btn-subscriber'
        title='Action Details'
        onClick={handleClick}>
        <i className="fa-light fa-circle-info"/>
      </button>
      {showOverlay && (
        <ActionDetailsOverlay
          row={row}
          onClose={() => setShowOverlay(false)}
        />
      )}
    </StyledCell>
  );
};

const StyledCell = styled.td`
  white-space:nowrap;
  ${props => props.paddingLeft && css`
    padding-left: ${props.paddingLeft}px !important;
  `}
  
  .btn-subscriber{
    margin-left:5px;
  }
`;

ActionsCell.propTypes = {
  value: PropTypes.any,
  row: PropTypes.object,
  className: PropTypes.string
};

export default ActionsCell;